export default __webpack_public_path__ + "static/media/ministry-active.8d4f505a.svg";